import { render, staticRenderFns } from "./ged.vue?vue&type=template&id=1996754e"
import script from "./ged.vue?vue&type=script&lang=ts"
export * from "./ged.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports